export default "__VITE_ASSET__BvNee4VP__"